import React from "react";

const AboutMissionSection = () => {
  return (
    <section className="section section-soft about-mission-section">
      <div className="container">
        <div className="about-mission-grid">
          <div>
            <p className="eyebrow">Our Mission</p>
            <h2>Help ambitious professionals move faster with less stress.</h2>
          </div>
          <div>
            <p>
              Our mission is to help ambitious professionals, especially
              international students and visa holders, land verified job offers
              faster and with less stress.
            </p>
            <p>
              We combine human guidance, recruiter outreach, profile
              optimization, and disciplined follow-through so candidates can
              stop guessing and start moving through a managed job-search
              process.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMissionSection;
